import { RoutePaths } from 'src/constants';
import { session } from 'src/modules/session';

import {
  AuthControllerApi,
  BidControllerApi,
  CarDetailControllerApi,
  ConfigControllerApi,
  Configuration,
  DealerControllerApi,
  DeliveryAddressControllerApi,
  ExportControllerApi,
  ExportImagesControllerApi,
  ListCarsControllerApi,
  MfaLoginControllerApi,
  PackageApi,
  PacketControllerApi,
  PriceCalculationControllerApi,
  PurchaseAgentControllerApi,
  RecommendationControllerApi,
  SearchAgentControllerApi,
} from './generated/api';
import { ManualImportControllerApi, TransportationControllerApi, WatchListControllerApi } from './generated/api/api';

export const isPublicServicePath = () =>
  window.location.pathname.startsWith(
    // Omit path param
    RoutePaths.imageExport.split('/').slice(0, -1).join('/'),
  );

export const apiBasePath = process.env.REACT_APP_API_URL || window.location.origin;

const ApiConfiguration = new Configuration({
  basePath: apiBasePath,
  // Contract: return a string. It used to navigate and write localStorage from in here, which meant
  // a request being constructed could redirect the whole document -- see docs/session-auth-refactor.md.
  // Deciding to re-authenticate now belongs to the session module alone; this only reports the token.
  accessToken: () => session.tokenForRequest(),
});

const ApiService = {
  bids: new BidControllerApi(ApiConfiguration),
  calcPrice: new PriceCalculationControllerApi(ApiConfiguration),
  export: new ExportControllerApi(ApiConfiguration),
  listCars: new ListCarsControllerApi(ApiConfiguration),
  searchAgent: new SearchAgentControllerApi(ApiConfiguration),
  config: new ConfigControllerApi(ApiConfiguration),
  dealer: new DealerControllerApi(ApiConfiguration),
  deliveryAddress: new DeliveryAddressControllerApi(ApiConfiguration),
  auth: new AuthControllerApi(ApiConfiguration),
  packet: new PacketControllerApi(ApiConfiguration),
  imageExport: new ExportImagesControllerApi(ApiConfiguration),
  detail: new CarDetailControllerApi(ApiConfiguration),
  importController: new ManualImportControllerApi(ApiConfiguration),
  transportationController: new TransportationControllerApi(ApiConfiguration),
  watchListController: new WatchListControllerApi(ApiConfiguration),
  packageApi: new PackageApi(ApiConfiguration),
  purchaseAgent: new PurchaseAgentControllerApi(ApiConfiguration),
  recommendation: new RecommendationControllerApi(ApiConfiguration),
  mfaLogin: new MfaLoginControllerApi(ApiConfiguration),
};

export default ApiService;
